import { FC, useEffect, useState } from "react";

import __ from "web/Layout/Translations";

import MinusIcon from "web/assets/icons/minus.svg";
import PlusIcon from "web/assets/icons/plus.svg";

import type { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./plusMinusInput.scss";

interface IDomesticTourismFormPlusMinusInputProps {
  currentValue?: number;
  minValue?: number;
  maxValue?: number;
  onChange: (val: number) => void;
  label?: string;
  id?: string;
  isOpen?: boolean;
}

const DomesticTourismFormPlusMinusInput: FC<
  PropsWithClasses<IDomesticTourismFormPlusMinusInputProps>
> = ({
  currentValue = 1,
  minValue = 1,
  maxValue = 10,
  onChange = () => {},
  classes = {},
  label = "",
  id,
  isOpen = true,
}) => {
  const [current, setCurrent] = useState(currentValue);

  useEffect(() => {
    onChange(current);
  }, [current]);

  return (
    <div>
      <span id={`${id}-instruction`} className="visually-hidden">
        {__(
          `Użyj przycisków zwiększ i zmniejsz liczbę, aby zmienić liczbę${
            label ? ` ${label}` : ""
          }`
        )}
      </span>
      <div className={classes.root}>
        <button
          type="button"
          className={classes.button}
          disabled={!isOpen || current <= minValue}
          tabIndex={isOpen ? 0 : -1}
          onClick={() => {
            setCurrent(current - 1);
          }}
          aria-label={`${__("Zmniejsz liczbę")}${label ? ` ${label}` : ""}`}
        >
          <MinusIcon className={classes.icon} />
        </button>
        <input
          className={classes.input}
          value={current}
          aria-describedby={`${id}-instruction`}
          readOnly
          id={id}
          aria-label={`${__("Liczba")}${label ? ` ${label}` : ""}`}
          disabled={!isOpen}
          tabIndex={isOpen ? 0 : -1}
        />
        <button
          type="button"
          className={classes.button}
          disabled={!isOpen || current >= maxValue}
          tabIndex={isOpen ? 0 : -1}
          onClick={() => {
            setCurrent(current + 1);
          }}
          aria-label={`${__("Zwiększ liczbę")}${label ? ` ${label}` : ""}`}
        >
          <PlusIcon className={classes.icon} />
        </button>
      </div>
    </div>
  );
};

export default classify<
  PropsWithClasses<IDomesticTourismFormPlusMinusInputProps>
>(defaultClasses)(DomesticTourismFormPlusMinusInput);
